import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

const TitleStyles = css`
  line-height: 25px;
  font-size: 21px;
  font-weight: bold;
`;

const ReservationWrapper = styled.div`
  padding: 21px 0;
  @media only screen and (max-width: 767px) {
    padding: 0;
  }
  .reservation-tab-bar,
  .reservation-mobile-tab-bar {
    .ant-tabs-nav-list {
      width: 100%;
    }
    .ant-tabs-tab {
      display: flex;
      justify-content: center;
    }

    @media only screen and (max-width: 767px) {
      .ant-tabs-nav-operations {
        &.ant-tabs-nav-operations-hidden {
          display: none;
        }
      }
    }
  }
  .cancellation_policy {
    font-weight: 700;
    color: #0036B1;
    cursor: pointer;
    :hover {
      text-decoration: underline;
    }
  }
  .reservation-page-container {
    @media (min-width: 1200px) {
      max-width: 1366px !important; // ToDo: Need to change Container and to fix max sizes in the future
      width: 100%;
    }
  }

  .reservation-tab-bar {
    margin-bottom: 20px;
    &.chat-active {
      margin-bottom: 0;
    }
    .ant-tabs-tab {
      width: 50%;
      text-align: center;
      font-weight: normal;
      padding-top: 1px;
      padding-bottom: 18px;
      color: ${themeGet('text.3', '8d8d8d')};
      .ant-tabs-tab-btn {
        // font-weight: bold;
      }
      &.ant-tabs-tab-active {
        .ant-tabs-tab-btn {
          color: ${themeGet('text.4', '#323232')};
          font-weight: bold;
        }
      }
    }
    .ant-tabs-ink-bar {
      background-color: ${themeGet('primary.0', '#194AB9')};
    }
  }
`;

export const Sidebar = styled.aside`
  height: calc(100vh - 105px);
  @media only screen and (max-width: 767px) {
    height: calc(100vh - 115px);
  }
  position: relative;
  background-color: ${themeGet('color.1', '#ffffff')};
  box-shadow: 0 3px 6px ${themeGet('boxShadow.1', 'rgba(26, 68, 116, 0.16)')};
  @media only screen and (max-width: 767px) {
    box-shadow: none;
    margin-bottom: 0;
  }
  .cancelReservationButton {
    & button {
      font-size: 14px;
    }
    width: 100%;
    display: flex;
    justify-content: center;
  }
`;

export const SidebarScrollOuter = styled.div`
  position: relative;
  height: calc(100vh - 105px);
  // &.with-actions {
  //   height: calc(100vh - 213px);
  //   &.with-payment {
  //     height: calc(100vh - 292px);
  //   }
  // }
`;

export const SidebarScrollInner = styled.div`
  ${'' /* position: absolute; */}
  overflow: hidden;
  max-height: 100%;
  width: 100%;
`;

export const Header = styled.div`
  display: flex;
  margin-bottom: 16px;
`;

export const MarinaImageWrapper = styled.div`
  min-width: 137px;
  width: 137px;
  height: 108px;
  margin-right: 16px;
  border-radius: 4px;
  overflow: hidden;
  img {
    object-fit: cover;
    height: 100%;
  }
`;

export const MarinaTitleWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  padding-right: 5px;
  .link {
    &:hover {
      h3 {
        color: ${themeGet('primary.0', '#194AB9')};
      }
    }
  }
`;

export const MarinaTitle = styled.h3`
  font-weight: bold;
  font-size: 27px;
  line-height: 32px;
  color: ${themeGet('text.11', '#333333')};
  transition: color 0.3s ease;
  margin-top: 4px;
  margin-bottom: 2px;
  @media only screen and (max-width: 991px) {
    margin-top: 0;
    font-size: 21px;
    line-height: 25px;
  }
  @media only screen and (max-width: 767px) {
    font-size: 20px;
    line-height: 27px;
  }
`;

export const MarinaInfo = styled.p`
  font-size: 15px;
  line-height: 18px;
  color: ${themeGet('text.12', '#828282')};
  margin-bottom: 0;
`;

export const Body = styled.div`
  padding: 24px 18px;
  .message_button {
    display: none;
    margin-top: 10px;
    min-width: 94px;
    font-weight: bold;
    border-color: ${themeGet('primary.0', '#194AB9')};
    background-color: ${themeGet('primary.0', '#194AB9')};
    @media only screen and (max-width: 767px) {
      display: block;
      align-self: flex-start;
    }
  }
  @media only screen and (max-width: 767px) {
    padding: 0 20px 18px;
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 31px;
  h3 {
    margin-bottom: 0;
    font-size: 21px;
    line-height: 24px;
    color: ${themeGet('text.4', '#323232')};
  }
  @media only screen and (max-width: 767px) {
    position: relative;
    h3 {
      font-size: 20px;
    }
  }
`;

export const Title = styled.h3`
  ${TitleStyles};
  margin-bottom: 16px;
  color: ${themeGet('text.0', '#2c2c2c')};
  display: flex;
  justify-content: space-between;
  .title-info {
    color: #7e7e7e;
    font-size: 14px;
    font-weight: normal;
  }
  &.empty-price-title {
    margin-bottom: 20px;
  }
  span.expired {
    text-decoration: line-through;
    color: ${themeGet('color.29', '#cccccc')};
  }
`;

export const SecondTitle = styled.h3`
  ${TitleStyles};
  margin-bottom: 24px;
  color: ${themeGet('text.0', '#2c2c2c')};
  display: flex;
  justify-content: space-between;
  .title-info {
    color: #7e7e7e;
    font-size: 14px;
    font-weight: normal;
  }
  &.empty-price-title {
    margin-bottom: 20px;
  }
  span.expired {
    text-decoration: line-through;
    color: ${themeGet('color.29', '#cccccc')};
  }
`;

export const Divider = styled.div`
  margin-bottom: 16px;
  border-bottom: 1px solid ${themeGet('border.1', '#E8E8E8')};
  &.actions-divider {
    margin-bottom: 29px;
    @media only screen and (max-width: 767px) {
      display: none;
    }
  }
  &.payments-divider {
    display: none;
    @media only screen and (max-width: 767px) {
      display: block;
      margin-bottom: 29px;
    }
  }
`;

export const Section = styled.div`
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
  &.vessel-section {
    margin-bottom: 10px;
  }
  &.date-section {
    margin-bottom: 20px;
  }
  &.payment-section {
    margin-bottom: 12px;
  }
`;

export const SectionTitle = styled.h4`
  line-height: 19px;
  font-size: 17px;
  font-weight: bold;
  margin-bottom: 5px;
`;

export const SectionContent = styled.div`
  position: relative;
  width: 100%;
  &.popeye-section {
    .ant-switch-small {
      width: 26.7px;
      height: 13.3px;
    }
    .ant-switch-handle {
      height: 10px;
      width: 10px;
    }
    .ant-switch-checked {
      background-color: ${themeGet('primary.0', '#194AB9')};
    }
  }
`;

export const MainInfo = styled.p`
  display: flex;
  justify-content: space-between;
  margin-bottom: 4px;
  color: ${themeGet('text.11', '#333333')};
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  &.dates-info {
    align-items: center;
    margin-bottom: 0;
  }
  &.dates-error {
    color: ${themeGet('warning.1', '#EB5757')};
    font-weight: bold;
    margin-top: 8px;
  }
  &.popeye-info {
    margin-top: 5px;
    align-items: center;
    color: ${themeGet('text.4', '#323232')};
    font-weight: bold;
  }
  &.nights-info {
    font-size: 17px;
    line-height: 24px;
    font-weight: bold;
    margin-bottom: 0;
  }
  &.contract_name-info {
    font-size: 20px;
    line-height: 24px;
    font-weight: bold;
    margin-bottom: 0;
  }
  &.membership-card-info {
    margin-left: 7px;
  }
  span.popeye-discount {
    color: #eb5757;
  }
  span.term {
    display: flex;
    align-items: center;
    svg {
      margin-right: 9px;
    }
  }
  span.expired {
    text-decoration: line-through;
    color: ${themeGet('color.29', '#cccccc')};
  }
  &.price-info {
    margin-bottom: 11px;
  }
  &.price-requested-redeem-nights {
    margin-top: 12px;
    font-weight: bold;
  }
`;

export const StatusWrapper = styled.div`
  align-self: flex-end;
  margin-top: auto;
  @media only screen and (max-width: 767px) {
    position: absolute;
    top: 4px;
    right: 0;
  }
`;

export const AdditionalInfo = styled.p`
  color: ${themeGet('text.1', '#909090')};
  margin-bottom: 0;
  &.price-info {
    margin-bottom: 21px;
  }
`;

export const Discounts = styled.div`
  margin-top: 6px;
  margin-bottom: 12px;
`;

export const ReasonField = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 350px;
  row-gap: 10px;
  margin: 0 auto;
  padding-top: 10px;
  input {
    border-radius: 3px;
    border-color: ${themeGet('border.3', '#e6e6e6')};
    height: 47px;
    &:focus,
    &:hover {
      border-color: ${themeGet('border.3', '#e6e6e6')};
      box-shadow: none;
    }
  }
  .reason-field-error {
    color: ${themeGet('text.5', '#f5222d')};
    font-size: 14px;
    transition: color 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  .ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) {
    .ant-select-selector {
      border-color: ${themeGet('primary.0', '#194AB9')};
      box-shadow: none;
    }
  }
  .ant-select:not(.ant-select-disabled):hover {
    .ant-select-selector {
      border-color: ${themeGet('primary.0', '#194AB9')};
    }
  }
`;

export const ReservationDetailsMobileWrapper = styled.div`
  position: relative;
  // &.with-actions {
  //   padding-bottom: 100px;
  //   &.with-payment {
  //     padding-bottom: 198px;
  //   }
  // }
  .cancelReservationButton {
    & button {
      font-size: 14px;
    }
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }
`;

export const ReservationActions = styled.div`
  width: 100%;
  display: flex;
  margin-bottom: 48px;
  @media only screen and (max-width: 767px) {
    margin-bottom: 0;
    width: 100%;
    position: fixed;
    bottom: 52px;
    left: 0;
    z-index: 1;
    background-color: ${themeGet('color.1', '#ffffff')};
    border-top: 1px solid ${themeGet('border.1', '#E8E8E8')};
    padding: 15px 20px;
  }
`;

export const ConnectedCardIconWrapper = styled.div`
  position: relative;
  width: 104px;
  height: 67px;
  margin-top: 22px;
  margin-bottom: 8px;
  margin-left: 7px;
  .anticon {
    position: absolute;
    top: -7px;
    left: -7px;
  }
`;

export const GroupNotice = styled.span`
  font-size: 14px;
  margin-bottom: 24px;
  font-weight: normal;
  margin-left: 27px;
  line-height: 1;
  color: #2c2c2c;

  span {
    color: ${themeGet('text.1', '#909090')};
    font-weight: 400;
  }

  @media only screen and (max-width: 1260px) {
    font-size: 14px;
  }
  @media only screen and (max-width: 767px) {
    font-size: 14px;
    margin-left: 0;
    margin-top: 24px;
    margin-bottom: 24px;
  }
`;

export const GroupTitle = styled.h4`
  font-size: 21px;
  margin-bottom: 21px;
  font-weight: bold;
  margin-left: 27px;
  line-height: 1.2;
  color: #2c2c2c;

  span {
    color: ${themeGet('text.1', '#909090')};
    font-weight: 400;
  }

  @media only screen and (max-width: 1260px) {
    font-size: 21px;
  }
  @media only screen and (max-width: 767px) {
    font-size: 21px;
    margin-left: 0;
    margin-top: 24px;
    margin-bottom: 24px;
  }
`;

export const SectionHeader = styled.div`
  font-size: 17px;
  font-weight: bold;
  line-height: normal;
  color: #ffffff;

  .section-number {
    display: inline-block;
    border: solid 1.5px #ffffff;
    border-radius: 50%;
    margin: 0 11px 0 0;
    height: 26px;
    width: 26px;
    padding-top: 1px;
    text-align: center;
  }
`;

export const CollapseWrapper = styled.div`
  .ant-collapse-icon-position-right
    > .ant-collapse-item
    > .ant-collapse-header {
    height: 42px;
    padding-top: 8px;
    padding-bottom: 8px;
    margin-top: 20px;
    border-radius: 3px;
    background-color: #495e6e;
    .ant-collapse-arrow {
      right: 24px;
      svg {
        stroke: #ffffff;
        stroke-width: 80px;
      }
    }

    @media only screen and (max-width: 767px) {
      border-radius: 0;
    }
  }

  .ant-collapse-content > .ant-collapse-content-box {
    padding: 0px;
  }

  .ant-collapse-borderless {
    background-color: white;
  }

  .ant-collapse > .ant-collapse-item {
    border: 0;
  }
`;

export const PaymentSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  &.paid {
    justify-content: space-between;
  }
  @media only screen and (max-width: 767px) {
    padding-right: 20px;
    padding-left: 20px;
    padding-bottom: 112px;
  }
`;

export const MessagingHeader = styled.div`
  padding: 17px 1px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  position: relative;
  z-index: 2;
  .back_button {
    display: flex;
    align-items: center;
    font-size: 21px;
    font-weight: bold;
  }
`;

export const BackButtonTitle = styled.span`
  margin-left: 7px;
  font-size: 14px;
`;

export const PaymentDetailsTitle = styled.h4`
  font-size: 21px;
  font-weight: bold;
  line-height: 24px;
  color: ${themeGet('text.4', '#323232')};
  margin-left: 30px;
  margin-bottom: 17px;
  @media only screen and (max-width: 767px) {
    margin-left: 0;
    padding-left: 20px;
    padding-right: 20px;
  }
`;

export const PaymentDetailsAlert = styled.div`
  background-color: ${themeGet('color.28', '#e6f7ff')};
  min-height: 52px;
  padding: 16px 21px 18px;
  margin-bottom: 36px;
  color: ${themeGet('text.0', '#2c2c2c')};
  font-size: 14px;
  line-height: 18px;
  margin-left: 28px;
  @media only screen and (max-width: 767px) {
    margin-left: 20px;
    margin-right: 20px;
    margin-bottom: 100px;
  }
`;

export const ActionSection = styled.div`
  margin-top: 32px;
  margin-bottom: 32px;
  @media only screen and (max-width: 767px) {
    margin-top: 0;
    padding: 0 20px;
  }
`

export const ActionTitle = styled.div`
  padding: 0 12px;
  color: ${themeGet('text.0', '#2c2c2c')};
  font-size: 17px;
  line-height: 24px;
  margin-bottom: 1px;
  font-weight: bold;
`

export const Actions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: column;
  & button {
      font-size: 14px;
    }
`

export const ContactInfo = styled.div`
padding: 0 12px;
color: ${themeGet('text.0', '#2c2c2c')};
font-size: 13px;
line-height: 24px;
margin-bottom: 10px;
font-weight: bold;
`

export const ContactInfoTitle = styled.div`
font-size: 14px;
font-weight: bold;
margin-bottom: 1px;
margin-top: 10px;
`

export const ContactDetails = styled.div`
/* Styles for contact details */
div {
    display: flex;
    align-items: baseline;
    gap: 10px; /* Adjust spacing between Email title and button */
  }

`

export const ContactDetail = styled.div`
  display: flex;
  align-items: baseline;
  font-size: 13px;
  line-height: 24px;
  color: ${props => (props.phone ? '#0036B1' : themeGet('text.0', '#2c2c2c'))};
  cursor: ${props => props.phone? 'pointer': 'default'};
  font-weight: normal;
  border-radius: 4px;
  gap: 8px;
  font-style: normal;
  line-height: 120%;
  padding: ${props => props.phone? '7.5px 7px' : 'none'};
`;


export const SuggestionsSection = styled.div`
  padding: 6px 0 24px 0;
`

export const SuggestionsTitle = styled.h4`
  display: flex;
  align-items: center;
  font-size: 17px;
  font-weight: bold;
  margin-bottom: 6px;
  color: ${themeGet('text.13', '#121a2c')};
  .suggestion-dates-icon {
    margin-right: 10px;
    font-size: 21px;
  }
`

export const SuggestionsDescription = styled.p`
  font-size: 14px;
  color: ${themeGet('text.13', '#121a2c')};
  margin-bottom: 10px;
`

export const SuggestionsList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  padding: 7px 6px;
  border-radius: 4px;
  border: 1px solid ${themeGet('border.12', '#f2bb06')};
  background-color: ${themeGet('color.41', '#fff7dd')};
  margin-bottom: 24px;
`

export const CANCELLATION_POLICY = styled.span`
  color: #0036B1;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`

export const Suggestion = styled.li`
  color: ${themeGet('text.13', '#121a2c')};
  font-size: 14px;
  text-decoration: underline;
  cursor: pointer;
  padding: 6px 10px;
  border: 1px solid transparent;
  border-radius: 4px;
  ${({ selected }) => selected && css`
    text-decoration: none;
    background-color: ${themeGet('color.1', '#ffffff')};
    border-color: ${themeGet('border.13', '#121A2C')};
  ` }
`

export default ReservationWrapper;
